import { render, staticRenderFns } from "./address-street-standard.vue?vue&type=template&id=e1375b74&scoped=true&"
import script from "./address-street-standard.vue?vue&type=script&lang=js&"
export * from "./address-street-standard.vue?vue&type=script&lang=js&"
import style0 from "./address-street-standard.vue?vue&type=style&index=0&id=e1375b74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1375b74",
  null
  
)

export default component.exports